import { Button } from '@/shared/ui/button';
import { Save, X } from 'lucide-react';

interface PhotoIndexControlsProps {
  savePhotoMarkers: () => void;
  setPhotoIndexMode: (value: boolean) => void;
  setShowMarkerToolbar: (value: boolean) => void;
  setSelectedMarkers: (markers: Set<number>) => void;
}

const PhotoIndexControls = ({
  savePhotoMarkers,
  setPhotoIndexMode,
  setShowMarkerToolbar,
  setSelectedMarkers,
}: PhotoIndexControlsProps) => {
  return (
    <div className="flex border rounded-lg overflow-hidden">
      <Button
        variant="ghost"
        size="sm"
        onClick={savePhotoMarkers}
        className="rounded-none border-r text-primary hover:text-primary"
      >
        <Save className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => {
          setPhotoIndexMode(false);
          setShowMarkerToolbar(false);
          setSelectedMarkers(new Set());
        }}
        className="rounded-none text-destructive hover:text-destructive"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default PhotoIndexControls;
